import { render, staticRenderFns } from "./TableMateriaisLB.vue?vue&type=template&id=2216f663&scoped=true&"
import script from "./TableMateriaisLB.vue?vue&type=script&lang=js&"
export * from "./TableMateriaisLB.vue?vue&type=script&lang=js&"
import style0 from "./TableMateriaisLB.vue?vue&type=style&index=0&id=2216f663&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2216f663",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})
